import IpubIcon from './src/main'

/* istanbul ignore next */
IpubIcon.install = function(Vue) {
  Vue.component(IpubIcon.name, IpubIcon)
}

export default IpubIcon
